var map = {
	"./IMG_0854.JPG": 4061,
	"./IMG_0855.JPG": 7104,
	"./IMG_0856.JPG": 2236,
	"./IMG_0857.JPG": 7167,
	"./IMG_0858.JPG": 2990,
	"./IMG_0859.JPG": 2001,
	"./IMG_0860.JPG": 5740,
	"./IMG_0861.JPG": 1001,
	"./IMG_0862.JPG": 9886,
	"./IMG_0863.JPG": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8790;